/**
 * Created by ubuntuuser on 18-9-11.
 */
let SIGN_REGEXP = /([yMdhsm])(\1*)/g
let DEFAULT_PATTERN = 'yyyy-MM-dd'
function padding (s, len) {
  var l = len - (s + '').length
  for (var i = 0; i < l; i++) { s = '0' + s }
  return s
}
export default {
  formatDate: {
    format: function (date, pattern) {
      var d = new Date(date.getTime())
      pattern = pattern || DEFAULT_PATTERN
      return pattern.replace(SIGN_REGEXP, function ($0) {
        switch ($0.charAt(0)) {
          case 'y': return padding(d.getFullYear(), $0.length)
          case 'M': return padding(d.getMonth() + 1, $0.length)
          case 'd': return padding(d.getDate(), $0.length)
          case 'w': return d.getDay() + 1
          case 'h': return padding(d.getHours(), $0.length)
          case 'm': return padding(d.getMinutes(), $0.length)
          case 's': return padding(d.getSeconds(), $0.length)
        }
      })
    },
    parse: function (dateString, pattern) {
      var matchs1 = pattern.match(SIGN_REGEXP)
      var matchs2 = dateString.match(/(\d)+/g)
      if (matchs1.length === matchs2.length) {
        var _date = new Date(1970, 0, 1)
        for (var i = 0; i < matchs1.length; i++) {
          var _int = parseInt(matchs2[i])
          var sign = matchs1[i]
          switch (sign.charAt(0)) {
            case 'y':
              _date.setFullYear(_int)
              break
            case 'M':
              _date.setMonth(_int - 1)
              break
            case 'd': _date.setDate(_int)
              break
            case 'h': _date.setHours(_int)
              break
            case 'm': _date.setMinutes(_int)
              break
            case 's': _date.setSeconds(_int)
              break
          }
        }
        return _date
      }
      return null
    },
    formatPublish (data) {
      var diff = new Date().getTime() - data * 1000
      if (diff / (1000 * 60 * 60 * 24) > 1) {
        return this.formatDate.format(new Date(data * 1000), 'yyyy-MM-dd')
      } else {
        if (diff / (1000 * 60 * 60) >= 1) {
          return parseInt(diff / (1000 * 60 * 60)) + '小时前'
        } else {
          return parseInt(diff / (1000 * 60)) + '分钟前'
        }
      }
    }
  },
  // 格式化时间，默认日期和时间换行
  formatTimeStamp (time, br = true) {
    let str = ''
    if (br) {
      str = 'yyyy-MM-dd<br> hh:mm:ss'
    } else {
      str = 'yyyy-MM-dd hh:mm:ss'
    }
    return this.formatDate.format(new Date(time * 1000), str)
  },
  // 错误码
  getErrorMsg (code) {
    switch (code) {
      case -1001:
        return 'GET参数缺失'
      case -1002:
        return 'POST参数缺失'
      case -1003:
        return 'DELETE参数缺失'
      case -1004:
        return 'PUT参数缺失'
      case -1101:
        return 's参数太短'
      case -1102:
        return 's参数解密失败'
      case -1103:
        return '缓存超时'
      case -1104:
        return '手机格式错误'
      case -1105:
        return 'ip不在白名单中'
      case -1106:
        return '密码错误'
      case -1107:
        return '单个参数出现太多'
      case -1108:
        return '效果类型错误'
      case -1109:
        return '参数错误'
      case -1110:
        return '记录不存在'
      case -1111:
        return '记录已存在'
      case -1113:
        return '没有操作权限'
      case -1114:
        return '金额不能为零'
      case -2001:
        return '用户不存在'
      case -2002:
        return '用户登陆过期'
      case -2003:
        return '用户支付宝账号错误'
      case -2004:
        return '用户余额不足'
      case -2005:
        return '用户已验证用户关系'
      case -2006:
        return '用户关系不存在'
      case -2007:
        return '用户未验证关系'
      case -2008:
        return '用户账号错误'
      case -2009:
        return '用户已签到'
      case -2010:
        return '用户登陆未授权'
      case -2011:
        return '用户被封杀'
      case -2012:
        return 'app用户已绑定微信'
      case -2013:
        return '微信已绑定app用户'
      case -2014:
        return 'app用户解绑微信公众号失败'
      case -2015:
        return '用户上传头像格式错误'
      case -2016:
        return '新手任务不允许提交'
      case -2017:
        return '新手任务已完成'
      case -2018:
        return '用户验证手机次数太多'
      case -2019:
        return '手机验证码超时'
      case -2020:
        return '手机验证码错误'
      case -2021:
        return '用户已绑定手机'
      case -2022:
        return '手机已绑定用户'
      case -2023:
        return '用户已绑定师傅'
      case -2024:
        return '用户未绑定微信支付'
      case -2025:
        return '小助手渠道包找不到'
      case -2026:
        return '用户邀请太少'
      case -2027:
        return '用户验证次数错误'
      case -2028:
        return '用户未关注公众号'
      case -2029:
        return '用户支付失败'
      case -2030:
        return '用户支付任务已完成'
      case -2031:
        return '用户验证失败'
      case -2032:
        return '抽奖当天已分享'
      case -2033:
        return '抽奖次数不足'
      case -2034:
        return '提审上传错误'
      case -2035:
        return '任务无前提条件'
      case -2036:
        return '提审条件不满足'
      case -2037:
        return '任务已抢到'
      case -2038:
        return '支付信息不全'
      case -2039:
        return '用户名不合法'
      case -2040:
        return '用户已存在'
      case -2501:
        return '用户授权错误'
      case -2502:
        return '创建菜单失败'
      case -2701:
        return '广告没有预算'
      case -2702:
        return '广告无效'
      case -2703:
        return '广告订单已存在'
      case -2901:
        return '账单记录已经绑定'
      case -3001:
        return '查不到公众号信息'
      case -3002:
        return '兑换项不存在'
      case -3003:
        return '兑换记录不存在'
      case -3004:
        return '兑换记录没权限修改'
      case -3005:
        return '兑换记录不可以修改'
      case -3006:
        return '兑换太多'
      case -3007:
        return '没有定投兑换项'
      case -3008:
        return '分成项不存在'
      case -4001:
        return '广告平台回调订单已存在'
      default:
        return '错误码:' + code
    }
  },
  // 格式化模块
  formatMarket (market) {
    switch (market) {
      case 0:
        return '默认'
      case 1:
        return '贝贝家'
      case 2:
        return '电商'
      case 3:
        return '任务墙'
    }
  },
  // 格式化性别
  formatSex (sex) {
    switch (sex) {
      case 0:
        return '未知'
      case 1:
        return '男性'
      case 2:
        return '女性'
    }
  },
  formatUserStatus (status) {
    switch (status) {
      case 0:
        return '封杀'
      case 1:
        return '正常'
      case 2:
        return '禁止兑换'
      case 3:
        return '可疑'
    }
  },
  setCookie (name, value) {
    var time = 24 * 60 * 60 * 1000
    var exp = new Date()
    exp.setTime(exp.getTime() + time)
    document.cookie = name + '=' + value + ';expires=' + exp.toGMTString()
  },
  getCookie (name) {
    var strCookie = document.cookie
    var arrCookie = strCookie.split(';')
    for (var i = 0; i < arrCookie.length; i++) {
      var arr = arrCookie[i].split('=')
      arr[0] = arr[0].replace(' ', '')
      if (arr[0] === name) {
        return arr[1]
      } else {
        // return ''
      }
    }
  },
  cloneObj (obj) {
    let str = obj.constructor === Array ? [] : {}
    let newobj = obj.constructor === Array ? [] : {}
    if (typeof obj !== 'object') {
      return
    } else if (window.JSON) {
      str = JSON.stringify(obj)// 系列化对象
      newobj = JSON.parse(str)// 还原
    } else {
      for (var i in obj) {
        newobj[i] = typeof obj[i] === 'object' ? this.cloneObj(obj[i]) : obj[i]
      }
    }
    return newobj
  },
  getMonthList () {
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let monthLists = []

    for (let i = 0; i < 24; i++) {
      let monthStr = (month > 9) ? month.toString() : ('0' + month)
      let yearMonth = year.toString() + '-' + monthStr
      monthLists.push({'name': yearMonth, 'month': yearMonth})
      if (month === 1) {
        year = year - 1
        month = 12
      } else {
        month = month - 1
      }
    }

    return monthLists
  },
  isZero (floatNum) {
    var eps = 0.000001// 选择一个足够小的数作为阈值
    return Math.abs(floatNum) < eps
  },
  isNotZero (floatNum) {
    var eps = 0.000001// 选择一个足够小的数作为阈值
    return Math.abs(floatNum) >= eps
  },
  getSummaries (param, defaultColumns, startSumIndex = 0) {
    const { columns, data } = param
    const sums = []

    columns.forEach((column, index) => {
      // 从指定列之后才允许合计
      if (index < startSumIndex) {
        sums[index] = ''
        return
      }

      if (index === startSumIndex) {
        sums[index] = '合计'
        return
      }

      if (!column.property) {
        sums[index] = 'N/A'
        return
      }

      // 找到当前列配置
      const colConfig = defaultColumns.find(
        item => item.columnName === column.property
      )

      // 不需要合计 → 空
      if (!colConfig.isSum) {
        sums[index] = 'N/A'
        return
      }

      // 需要合计 → 自动求和
      const total = data
        .map(item => Number(item[column.property]) || 0)
        .reduce((a, b) => a + b, 0)

      sums[index] = total.toFixed(2)
    })

    return sums
  },

  /**
   * 复制文本到剪贴板
   * @param {String} text 需要复制的内容
   */
  copyText(text) {
    return new Promise((resolve, reject) => {
      if (!text) {
        reject('内容为空，无法复制')
        return;
      }
      // 优先现代剪贴板API
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text)
          .then(() => resolve())
          .catch(() => fallbackCopy(text, resolve, reject))
      } else {
        // http环境 / 低版本浏览器降级方案
        fallbackCopy(text, resolve, reject)
      }
    })
  },

  // 降级复制方案
  fallbackCopy(text, resolve, reject) {
    try {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.left = '-9999px'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      resolve()
    } catch (err) {
      reject('复制失败，请手动复制')
    }
  }
}



// WEBPACK FOOTER //
// ./src/script/util.js